import { UpdateDashboardInput } from '@akin-home/amplify';
import { DashboardModel } from '@akin-home/dashboards';
import { dashboardModelToCreateInput } from './dashboardModelToCreateInput';

export const dashboardModelToUpdateInput = (
  dashboard: DashboardModel
): UpdateDashboardInput => {
  return {
    ...dashboardModelToCreateInput(dashboard),
    id: dashboard.id,
  };
};
